// extracted by mini-css-extract-plugin
export default {"popularItem":"PopularItems_popularItem__-GCXi","heading":"PopularItems_heading__n271P","content":"PopularItems_content__8Dqi7","title":"PopularItems_title__9qTs8"};